import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  Grid,
  DialogActions,
  TextField,
} from "@material-ui/core";
import { LclDataContext } from "../../Contexts/LclDataContext";
import ButtonRestore from "../ButtonRestore";

const RestoreDpc = (props) => {
  const {
    dataType,
    truckId,
    itemData,
    week,
    day,
    itemId,
    ...otherProps
  } = props;
  const { createLclModel } = useContext(LclDataContext);
  const lclModel = createLclModel({ week });

  const displayColumns = [
    "eventTimeString",
    "eventType",
    "eventAddress",
    "conNoteNum",
    "sender",
    "receiver",
    "location",
    "zone",
    "eventItems",
    "kg",
    "m3",
    "dpc",
    "stopPay",
    "homeDelivery",
    "adminComments",
    "driverComments",
  ];

  return (
    <Dialog {...otherProps} fullWidth maxWidth="sm">
      <DialogTitle>Approval Screen</DialogTitle>
      <Divider />
      <DialogContent>
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="stretch"
          spacing={1}
        >
          {displayColumns.map((col) => {
            return (
              <Grid item key={col}>
                <Grid container>
                  <Grid item xs={3}>
                    {lclModel[col].displayName}:
                  </Grid>
                  <Grid item xs={9}>
                    <TextField
                      fullWidth
                      value={itemData[col]}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={true}
                      {...lclModel[col].textFieldProps}
                    />
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions>
        <ButtonRestore
          callback={props.onClose}
          variant="contained"
          color="primary"
          controller="lcls"
          truckId={truckId}
          week={week}
          day={day}
          itemId={itemId}
          itemData={itemData}
        />
      </DialogActions>
    </Dialog>
  );
};

export default RestoreDpc;
